import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'rtmTripGpsValues',
  initialState: {},
  reducers: {
    setGpsValues: (state, { payload }) => {
      state[payload.tripId] = payload.data
    },
  },
})

export const { setGpsValues } = slice.actions

export default slice.reducer

export const selectGpsValues = (tripId) => (state) =>
  state.rtmTripGpsValues[tripId]
